var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalsHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6545 9.33505V17.4942C19.6545 18.4482 19.6545 18.9253 19.547 19.316C19.2665 20.3354 18.47 21.1319 17.4505 21.4125C17.0598 21.52 16.5828 21.52 15.6288 21.52H15.5239C15.0284 21.52 14.7807 21.52 14.5758 21.4732C13.8772 21.3138 13.3317 20.7683 13.1722 20.0697C13.1255 19.8647 13.1255 19.617 13.1255 19.1215V15.9236C13.1255 14.3782 11.8727 13.1254 10.3273 13.1254V13.1254C8.78188 13.1254 7.52909 14.3782 7.52909 15.9236V19.1215C7.52909 19.617 7.52909 19.8647 7.48232 20.0697C7.32286 20.7683 6.77735 21.3138 6.07875 21.4732C5.87383 21.52 5.6261 21.52 5.13063 21.52H5.02578C4.07175 21.52 3.59474 21.52 3.204 21.4125C2.18456 21.1319 1.38808 20.3354 1.10753 19.316C1 18.9253 1 18.4482 1 17.4942V12.0482C1 10.7311 1 10.0726 1.16749 9.46466C1.31587 8.92604 1.55982 8.41847 1.88772 7.96614C2.25784 7.45554 2.77205 7.04418 3.80046 6.22145L9.1238 1.96278C9.82237 1.40393 10.8193 1.41954 11.5 2V2",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9836 4V5.24966C15.9836 6.14689 15.2844 6.87153 14.4202 6.87153H13.8828V6.93279L15.9843 9.4117",
    stroke: "#0460ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1724 5.41895H13.5",
    stroke: "#0460ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1724 4H13.5",
    stroke: "#0460ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6.5,
    r: 4.75,
    stroke: "#0460ff",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsHome);
export default __webpack_public_path__ + "static/media/goals_home.7b3ea675ed2236c59cfeea8e69c84cc2.svg";
export { ForwardRef as ReactComponent };